import { useState, useContext, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Modal,
  Form,
} from "react-bootstrap";
import { ProductContext } from "../context/AppContext";
import Swal from "sweetalert2";
import Header from "./Header";
import { useNavigate } from "react-router";
import axios from "axios";

function EFeedbackChat() {
  const [categories, setCategories] = useState([]);
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [feedbacks, setFeedbacks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [success, setSuccess] = useState(false);

  const authtoken = localStorage.getItem("token");
  const { userId, setClassSectionId, GetstudentData } =
    useContext(ProductContext);

  const { allConplaint = [], StudentProfileData } = useContext(ProductContext);

  console.log(allConplaint, "allConplaint 1500");

  const StudentId = GetstudentData?.id;
  const SelectClassId = GetstudentData?.class_section_id;

  const [formData, setFormData] = useState({
    category: "",
    subject: "",
    description: "",
    cls_sec_id: SelectClassId,
  });

  const [photo, setPhoto] = useState(null);

  const [getEFeedback, setGetEFeedback] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  
    const fetchMyLeavesData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://api.mirai.healthcare/api/head/feedback?student_id=${StudentId}`,
          {
            headers: {
              "x-auth": authtoken,
              "Content-Type": "application/json",
            },
          }
        );
        setGetEFeedback(response?.data);
      } catch (err) {
        console.error("API error Efeedback:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
useEffect(() => {
    fetchMyLeavesData();
  }, [StudentId, navigate]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

//   const handleFileChange = (e) => {
//     setPhoto(e.target.files[0]);
//   };
const handleFileChange = (e) => {
  const selectedFile = e.target.files[0];
  setFile(selectedFile);
  if (selectedFile) {
    setFilePreview(URL.createObjectURL(selectedFile));
  }
};



  const handleSubmit = async (e) => {
  e.preventDefault(); // ⛔️ stop default page reload

  if (!formData.category || !formData.subject || !formData.description) {
    alert("Please fill all required fields");
    return;
  }

  setLoading(true);
  const data = new FormData();
  data.append("student_id", StudentId);
  data.append("category", formData.category);
  data.append("subject", formData.subject);
  data.append("description", formData.description);
  data.append("created_by", StudentId);
  data.append("cls_sec_id", SelectClassId);

  // ✅ use 'file' instead of 'photo' (since you use handleFileChange)
  if (file) {
    data.append("file", file);
  }

  try {
    const response = await axios.post(
      "https://api.mirai.healthcare/api/head/feedback",
      data,
      {
        headers: {
          "x-auth": authtoken,
          "Content-Type": "multipart/form-data", // important for file uploads
        },
      }
    );

    if (response.status === 200) {
      alert("Your feedback has been successfully submitted.");
      setFormData({
        category: "",
        subject: "",
        description: "",
        cls_sec_id: SelectClassId,
      });
      setFile(null);
      setFilePreview(null);
      setShowModal(false);
      await fetchMyLeavesData();
    } else {
      alert("Failed to submit feedback");
    }
  } catch (error) {
    console.error("Error submitting feedback:", error);
    alert("Error: Failed to submit feedback");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <Header />
      <Container
        fluid
        className="py-5"
        style={{ paddingLeft: "25px", paddingRight: "25px" }}
      >
        <Row className="mt-5">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="fw-bold">Feedback</h2>
              <Button variant="primary" onClick={() => setShowModal(true)}>
                + Post Feedback
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="g-4">
          {getEFeedback?.data
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .map((item, index) => (
              <Col key={index} xs={12} md={6} lg={3}>
                <Card className="h-100 border-0 shadow-sm rounded-4">
                  <Card.Body className="d-flex flex-column">
                    <img
                      src={item?.attach_file?.link}
                      style={{ width: "100%", height: "200px" }}
                    />
                    <Card.Title className=" fs-18 pt-2 fw-semibold">
                      {item.subject}
                    </Card.Title>
                    {item.date && (
                      <Card.Text className="small mb-1 mt-1">
                        <strong>Date : </strong>{" "}
                        {new Date(
                          item?.date ? item.date.split("T")[0] : "N/A"
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </Card.Text>
                    )}
                    <div className="">
                      <span className="fw-semibold text-dark">Status:</span>{" "}
                      <span
                        className={`badge ${
                          item.status.toLowerCase() === "open"
                            ? "bg-success text-white"
                            : item.status.toLowerCase() === "escalated"
                            ? "bg-warning text-dark"
                            : "bg-light text-dark border"
                        }`}
                      >
                        {item.status}
                      </span>
                    </div>
                    {item?.description && (
                      <Card.Text className="text-muted mb-1 mt-1">
                        Description : {item?.description}
                      </Card.Text>
                    )}

                    {item?.chat_status !== "Ended" && (
                      <div className="feedback-actions">
                        <button
                          className="chat-btn btn btn-primary w-100"
                          onClick={() =>
  navigate("/efeedbackchat", {
    state: { FeedbackId: item?.id },
  })
}
                        >
                          Chat
                        </button>
                      </div>
                    )}

                    {/* {notice.file_upload && (
                      <Button
                        className="mt-3"
                        variant="primary"
                        href={notice.file_upload}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Attachment
                      </Button>
                    )} */}
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </Container>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        style={{ zIndex: 1050 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Submit Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Category</Form.Label>
              <select
                className="form-control bg-white text-dark"
                value={formData.category}
                onChange={(e) => handleChange("category", e.target.value)}
              >
                <option value="">Select Category</option>
                {allConplaint.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter subject"
                value={formData.subject}
                onChange={(e) => handleChange("subject", e.target.value)}
                required
              />
            </Form.Group>

            {/* Description Textarea */}
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter description"
                value={formData.description}
                onChange={(e) => handleChange("description", e.target.value)}
                required
              />
            </Form.Group>

            {/* File Attachment */}
            <Form.Group className="mb-4">
  <Form.Label>Attach File (optional)</Form.Label>
  <Form.Control
  type="file"
  accept="image/*,application/pdf"
  onChange={(e) => setFile(e.target.files[0])}
/>

</Form.Group>


            {/* Submit Button */}
            <div className="text-end">
              <Button type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Submitting...
                  </>
                ) : (
                  "Submit Feedback"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Attachment Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {filePreview && (
  <div className="text-center mb-3">
    <img
      src={filePreview}
      alt="Preview"
      style={{
        maxWidth: "200px",
        maxHeight: "200px",
        borderRadius: "8px",
        objectFit: "cover",
      }}
    />
  </div>
)}

        </Modal.Body>
      </Modal>
    </>
  );
}

export default EFeedbackChat;
